import { css } from 'styled-components';

import { Cell } from '../styles';

const BhFreshStyled = css`
  display: flex;
  flex-direction: column;
  gap: 1px;

  ${Cell}:nth-child(1) {
    height: 22%;
  }

  ${Cell}:nth-child(2) {
    height: 27%;
  }

  ${Cell}:nth-child(3) {
    height: 27%;
  }

  ${Cell}:nth-child(4) {
    height: 24%;
  }
`;

export default BhFreshStyled;
